module.exports = __webpack_public_path__ + "img/max-file-repeat--zip.e25e7d86.svg";